export function accordion() {
  const accordions = document.querySelectorAll('.js-accordion');
  accordions.forEach(accordion => {
    accordion.addEventListener('click', () => {
      accordion.classList.toggle('is-open');
      const content = accordion.nextElementSibling;
      const icon = accordion.querySelector('.p-top-faq__item-icon');
      
      if (content && content.classList.contains('p-top-faq__item-content')) {
        if (content.style.maxHeight) {
          content.style.maxHeight = null;
          content.style.paddingTop = 0;
          content.classList.remove('is-active');
          icon.classList.remove('is-active');
        } else {
          content.style.maxHeight = content.scrollHeight + "px";
          content.style.paddingTop = "24px";
          content.classList.add('is-active');
          icon.classList.add('is-active');
        }
      }
    });
  });
}

